import globals from "../partials/global-variables";
import { ButtonPrimary, ButtonNextInProgress } from "../partials/buttons";
import stylesConfig from "../styles.config";
import mediaQuery from "../abstract/media-query";

const buttonBackground = globals.colors.transparent;

export default {
  "@keyframes navigationSpinner": {
    "0%": {
      transform: "translate(-50%,-50%) rotate(0deg)",
    },
    "100%": {
      transform: "translate(-50%,-50%) rotate(360deg)",
    },
  },
  container: {
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "space-between",
    width: "100%",
    paddingBottom: 0,
    margin: 0,
    height: "auto",
    border: "none",
    "&.toLeft": {
      position: "relative",
      top: "-6px",
    },
    ".top-navigation &": {
      width: "50%",
      paddingBottom: 0,
      borderBottom: "none",
      marginTop: "-28px",
    },
    "& .navigation-back-button": {
      margin: "0 auto 0 10px",
      padding: "13px 10px",
      background: buttonBackground,
      border: "none",
      minWidth: "25px",
      cursor: "pointer",
      "& svg": {
        transform: "rotate(180deg)",
        transformOrigin: "center",
        "& path": {
          fill: stylesConfig.colors.secondary.spectrum500,
          [mediaQuery.hover]: {
            "&:hover": {
              fill: stylesConfig.colors.secondary.spectrum800,
            },
          },
        },
      },
      [`@media (${globals.breakpoints.$xs})`]: {},
      "[data-advisor-mode='RESULTS_PAGE'] &": {
        [`@media (${globals.breakpoints.$xs})`]: {},
      },
    },
    "& .navigation-next-button, & .navigation-submit-button, & .navigation-skip-button": {
      ...ButtonPrimary,
      marginRight: 0,
      background: stylesConfig.colors.secondary.spectrum500,
      borderColor: stylesConfig.colors.secondary.spectrum500,
      position: "relative",
      textTransform: "uppercase",
      borderRadius: 0,
      [mediaQuery.hover]: {
        "&:hover": {
          background: stylesConfig.colors.secondary.spectrum800,
        },
      },
      "&:active": {
        background: stylesConfig.colors.secondaryAccentColorVariants.dark,
      },
      [`@media (${globals.breakpoints.$xs})`]: {
        order: 2,
        width: "calc(50% - 5px)",
        paddingLeft: 0,
        paddingRight: 0,
        maxWidth: "215px",
      },
    },
    "& .navigation-next-button[disabled='disabled'], & .navigation-submit-button[disabled='disabled']": {
      background: stylesConfig.colors.secondary.spectrum200,
      borderColor: stylesConfig.colors.secondary.spectrum200,
      [mediaQuery.hover]: {
        "&:hover": {
          background: stylesConfig.colors.secondary.spectrum200,
          borderColor: stylesConfig.colors.secondary.spectrum200,
        },
      },
    },
    "& .navigation-next-button": {
      "&.navigation-next-button--disabled-appearance": {
        cursor: "default",
        background: stylesConfig.colors.secondary.spectrum200,
        borderColor: stylesConfig.colors.secondary.spectrum200,
        [mediaQuery.hover]: {
          "&:hover": {
            background: stylesConfig.colors.secondary.spectrum200,
            borderColor: stylesConfig.colors.secondary.spectrum200,
          },
        },
      },
    },
    "& .navigation-next-in-progress": {
      ...ButtonNextInProgress,
    },
  },
};
